import { css } from "styled-components";

export const responsiveFontStyle = (
	sizeLg: string,
	sizeSm: string,
	sizeXs: string,
	breakpointSm: string,
	breakpointXs: string,
	lineHeightMultiplier: number,
) => css`

    font-size: ${sizeLg};
    line-height: calc(${sizeLg} * ${lineHeightMultiplier});
  
    @media (max-width: ${breakpointSm}) {
      font-size: ${sizeSm};
      line-height: calc(${sizeSm} * ${lineHeightMultiplier});
    }
  
    @media (max-width: ${breakpointXs}) {
      font-size: ${sizeXs};
      line-height: calc(${sizeXs} * ${lineHeightMultiplier});
    }
  `;
